import "react-app-polyfill/ie9";
import React from "react";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./Themes/Tseppas/i18n";

// Error monitoring
import { initSentry } from "./lib/sentry";

// Initialize Sentry before app renders
initSentry();

// Apply Martel font globally
document.body.style.fontFamily = "'Martel', 'Georgia', 'Times New Roman', serif";
document.documentElement.style.fontFamily = "'Martel', 'Georgia', 'Times New Roman', serif";

toast.configure({
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
});

// Always load NewApp — handles both yeshtery and non-yeshtery builds
// REACT_APP_BUILD_YESHTERY is still used by Http.ts and OrgContext for API prefix selection
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}
const root = createRoot(container);

import("./App")
    .then(({ default: App }) => {
        root.render(
            <BrowserRouter>
                <I18nextProvider i18n={i18n}>
                    <App />
                </I18nextProvider>
            </BrowserRouter>
        );
    })
    .catch((e) => console.error("BUILD TARGET ERROR:", e));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
